import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {Text} from "../text/text";
import styles from "./ellipsis.module.scss";
import classNames from "classnames";

export class EllipsisComponentProps extends BaseProps {
  text: String;
  className: String;
  numOfMaxLines: Number;
  invert: Boolean;
}

export const Ellipsis = ({text, className, numOfMaxLines = 1, defaultDirection = false, children, style = {}, ...rest}: EllipsisComponentProps) => {
  const shouldUseLineClamp = text?.includes(' ') && (numOfMaxLines > 1)

  const textProps = {
    text,
    className: classNames(styles.container, className, {[styles.line_clamp]: shouldUseLineClamp}),
    defaultDirection,
    style: shouldUseLineClamp ? {
      WebkitLineClamp: `${numOfMaxLines || 2}`,
      ...style
    } : {...style},
    ...rest
  }

  return (
    <Text {...textProps}>
      {children}
    </Text>
  )
};
